const normalizeValue = <T>(value: T): T | undefined => value || undefined;

export default normalizeValue;
